// src/components/Pages/ApplicationPage.js
import React, { useContext } from 'react';
import { ProjectContext } from '../../context/ProjectProvider';
import ProjectList from '../Project/ProjectList';
import ExtractorsTable from '../Extractors/ExtractorsTable';
import ChatBox from '../Chat/ChatBox';
import PDFViewer from '../PDFViewer/PDFViewer';

const ApplicationPage = () => {
  const { isProjectListCollapsed, isCenterCollapsed } = useContext(ProjectContext);

  return (
    <div className="main-layout">
  {/* Columna izquierda: Lista de proyectos (opcionalmente colapsable) */}
  <div className={`column-left ${isProjectListCollapsed ? 'collapsed' : ''}`}>
  <ProjectList />
</div>


  {/* Columna central: solo si hay un proyecto seleccionado */}
  {!isCenterCollapsed && (
    <div
      className="column-center"
      style={{
        width: isProjectListCollapsed ? '60%' : '40%',
        transition: 'width 0.3s'
      }}
    >
      <div style={{ flex: 1, minHeight: 0 }}>
        <ExtractorsTable />
      </div>
      <div style={{ flexShrink: 0 }}>
        <ChatBox />
      </div>
    </div>
  )}

  {/* Columna derecha: PDFViewer ocupa el resto */}
  <div
    className="column-right"
    style={{
      width: isCenterCollapsed
        ? '100%' // ocupa toda la pantalla si no hay proyecto
        : isProjectListCollapsed
        ? '40%'  // cuando panel izquierdo está colapsado
        : '40%'  // puedes ajustar estos valores según tu gusto
    }}
  >
    <PDFViewer />
  </div>
</div>

  );
};

export default ApplicationPage;
